module.exports = __webpack_public_path__ + "static/media/ezgif-2-2c2669cad9.acce490b.gif";